(() => {
  const mobile = matchMedia('(max-width:749px)');
  const tracked = new Map();
  const fallback = document.getElementById('mh-mobile-wa-fallback');
  let pending = false;
  const visible = el => {
    if (!el.getClientRects().length) return false;
    for (let node = el; node && node !== document.body; node = node.parentElement) {
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
    }
    const box = el.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.bottom > 0 && box.top < innerHeight && box.right > 0 && box.left < innerWidth;
  };
  const refresh = () => {
    pending = false;
    if (!mobile.matches) {
      if (fallback && !fallback.hidden) fallback.hidden = true;
      tracked.forEach((original, el) => { el.style.bottom = original; el.removeAttribute('data-mh-wa-floating'); });
      tracked.clear();
      return;
    }
    const blocked = document.querySelector('cart-drawer.active,header-drawer>details[open],dialog[open],[class*="header-"].open:has([class*="header-sidebar-menu-inner-"])');
    const candidates = document.querySelectorAll('a[href*="wa.me/"],a[href*="api.whatsapp.com/"],[aria-label*="WhatsApp" i],[id*="whatsapp" i],[class*="whatsapp" i],[class*="wa__"]');
    let appVisible = false;
    candidates.forEach(candidate => {
      if (candidate === fallback || fallback?.contains(candidate)) return;
      for (let el = candidate; el && el !== document.body; el = el.parentElement) {
        if (getComputedStyle(el).position === 'fixed') {
          if (!tracked.has(el)) tracked.set(el, el.style.bottom);
          if (!el.hasAttribute('data-mh-wa-floating')) el.setAttribute('data-mh-wa-floating', '');
          if (visible(candidate)) appVisible = true;
          break;
        }
      }
    });
    if (fallback) {
      const hide = !!blocked || appVisible;
      if (fallback.hidden !== hide) fallback.hidden = hide;
      if (!tracked.has(fallback)) tracked.set(fallback, fallback.style.bottom);
    }
    tracked.forEach((original, el) => {
      if (!el.isConnected) { tracked.delete(el); return; }
      const rect = el.getBoundingClientRect();
      if (rect.height > 100 || !visible(el)) return;
      let bottom = 24;
      document.querySelectorAll('button[name="add"],button[name="checkout"],.mh-cyber-button,[data-mh-offer-reopen],#mh-offer-reopen').forEach(cta => {
        if (!visible(cta)) return;
        const box = cta.getBoundingClientRect();
        const vw = document.documentElement.clientWidth;
        if (box.top < innerHeight && box.bottom > 0 && box.right > vw - rect.width - 30 && box.left < vw - 10) {
          const projectedTop = innerHeight - bottom - rect.height;
          if (box.bottom > projectedTop && box.top < innerHeight - bottom) bottom = Math.max(bottom, innerHeight - box.top + 12);
        }
      });
      const value = `calc(${bottom}px + env(safe-area-inset-bottom, 0px))`;
      if (el.style.bottom !== value) el.style.bottom = value;
    });
  };
  const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(refresh); } };
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class','style','open','hidden']});
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  mobile.addEventListener('change',schedule);
  schedule();
})();
